
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-assistant",
      function () {
        return require("private-next-pages/ai-assistant.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-assistant"])
      });
    }
  